// extracted by mini-css-extract-plugin
export var brand = "_9p-9";
export var compact = "_9p-6";
export var extraSmall = "_9p-7";
export var icon = "_9p-0";
export var large = "_9p-4";
export var light = "_9p-1";
export var medium = "_9p-5";
export var outline = "_9p-b";
export var primaryDark = "_9p-a";
export var primaryLight = "_9p-8";
export var primaryModern = "_9p-c";
export var success = "_9p-2";
export var successSolid = "_9p-3";